import * as React from "react";
import "./workOption.scss";
import { classNames } from "../../utils";

interface IWorkOptionProps {
  text: string;
  selected: boolean;
  onClick?: () => void;
  children?: JSX.Element | JSX.Element[];
}

const WorkOption: React.FC<IWorkOptionProps> = (props) => {
  const { text, selected, onClick, children } = props;

  const handleClick = () => {
    if (onClick) onClick();
  };

  return (
    <div
      className={classNames({
        "work-status-option": true,
        "work-status-option--selected": selected,
      })}
      onClick={handleClick}
    >
      <span
        className="work-status-option__text"
        dangerouslySetInnerHTML={{ __html: text }}
      />

      {!!children && (
        <div className="work-status-option__background">{children}</div>
      )}
    </div>
  );
};

export default WorkOption;
